<!-- Fix (2026-08-26): all 3 buttons below were `type="submit"`. Every one of
     this shared component's host pages wraps it in `<form (ngSubmit)="onSubmit()">`
     (a leftover from before SAN-497 removed the dedicated Save button, back
     when a submit-type Save button's native form submission was the intended
     trigger for onSubmit()). A `type="submit"` button inside a form ALWAYS
     fires the form's native submit event on click, regardless of any (click)
     handler's own logic -- so every click here was ALSO invoking the host's
     onSubmit() a second time, redundantly, via ngSubmit, completely bypassing
     the validity gating each button's own (click) handler does. Reported
     live: clicking Next Step on an invalid Mentor form correctly showed
     "Please fill in all the required information" for a moment, but it was
     then silently replaced by onSubmit()'s own unconditional "...updated
     successfully" toast (onSubmit() doesn't check form validity, and several
     types' backend DTOs accept partial data, so that redundant save
     succeeded even though the form was incomplete). type="button" stops the
     native form-submit path entirely -- each button's own (click) handler is
     already a complete implementation (save, navigate, or emit), so nothing
     here relied on native submission. -->
<button type="button" id="kt_password_reset_submit" *ngIf="previousButtonVisible"
  class="btn btn-lg btn-dark text-white ls-2 text-uppercase fw-boldest fw-bolder me-4" (click)="handlePreviousClick()">
  <!-- [routerLink]="url" -->
  <span class="indicator-label d-none d-lg-block">Previous Step</span>
  <span class="indicator-label d-block d-lg-none">Previous</span>
</button>

<!-- Fix: handleClick() already blocked navigation + toasted an error when
     disableNavigation was true, but the button itself never looked disabled
     (stayed fully dark/clickable), same "!isPreviewPage" carve-out as
     handleClick()'s own check so preview pages are unaffected. -->
<button type="button" id="kt_password_reset_submit" *ngIf="!isLastPrimaryStep && buttonVisible"
  class="btn btn-lg btn-dark text-white ls-2 text-uppercase fw-boldest fw-bolder"
  [disabled]="disableNavigation && !isPreviewPage" (click)="handleClick()">
  <!-- [routerLink]="url" -->
  <span class="indicator-label d-none d-lg-block">Next Step</span>
  <span class="indicator-label d-block d-lg-none">Next</span>

</button>

<!-- SAN-500 — replaces Next Step, unconditionally, on the last primary step
     of each of the 9 primary-step components. Not gated by buttonVisible /
     CommonService.getNextRoute() (decisions 3 + 5): its presence no longer
     depends on editPageLinks contents, so it sits in the same position
     regardless of tenant custom-form tabs. -->
<button type="button" id="kt_last_primary_step_submit" *ngIf="isLastPrimaryStep && !alreadySubmitted"
  class="btn btn-lg btn-primary text-white ls-2 text-uppercase fw-boldest fw-bolder app-submit-step-btn"
  [disabled]="submitDisabled" (click)="handleSubmitClick()">
  <span class="indicator-label d-none d-lg-block">Submit</span>
  <span class="indicator-label d-block d-lg-none">Submit</span>
</button>
